import { render, staticRenderFns } from "./surface_post_comments.vue?vue&type=template&id=9820ef22&scoped=true&"
import script from "./surface_post_comments.vue?vue&type=script&lang=ts&"
export * from "./surface_post_comments.vue?vue&type=script&lang=ts&"
import style0 from "./surface_post_comments.vue?vue&type=style&index=0&id=9820ef22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9820ef22",
  null
  
)

export default component.exports